import $ from 'jquery'
import {Core} from './core'
import {Slider} from "./slider.js";

export class Tabs {
  constructor(scrollOnActiveTab) {
    this.$window = $(window)
    this.data = {
      active: 'active',
      tab: 'tab',
      tabLink: 'tab-link',
      tabContent: 'tab-content',
      tabDisableHash: 'tab-disable-hash',
      tabCanActiveMultiple: 'tab-can-active-multiple',
      tabCanDisableAll: 'tab-can-disable-all',
      tabCanDisableAllMobile: 'tab-can-disable-all-mobile',
      tabCanDisableAllDesktop: 'tab-can-disable-all-desktop'
    }
    this.containerData = 'tab'
    this.containerSelector = `[data-${this.containerData}]`
    this.isScriptWhoChangeUrl = false
    this.scrollOnActiveTab = scrollOnActiveTab

    if ($(this.containerSelector).length === 0) {
      return
    }

    $(this.containerSelector).on('click', `[data-${this.data.tabLink}]`, this.handleClickLinkTab.bind(this))
    $(document).ready(this.handleLoadHashScroll.bind(this))
    this.$window.on('hashchange', this.handleLoadHashScroll.bind(this))
  }

  handleClickLinkTab(e) {
    e.preventDefault()
    e.stopImmediatePropagation()

    let $tabLink = $(e.currentTarget)
    let $container = $tabLink.closest(this.containerSelector)
    let bp = 'md'
    let tabDisableHash = $container.data(this.data.tabDisableHash)

    if ($tabLink.hasClass(this.data.active)) {
      this.deactivateTab($tabLink)

      if (tabDisableHash) {
        this.removeHashUrl($tabLink)
      }

      if ($container.data(`${this.data.tabCanDisableAll}`) !== undefined) {
        this.deactivateTab($tabLink)

        if (tabDisableHash) {
          this.removeHashUrl($tabLink)
        }
      }

      if (Core.isBpLessThan(bp) && $container.data(`${this.data.tabCanDisableAllMobile}`) !== undefined) {
        this.deactivateTab($tabLink)

        if (tabDisableHash) {
          this.removeHashUrl($tabLink)
        }
      }

      if (Core.isBpGreaterThan(bp) && $container.data(`${this.data.tabCanDisableAllDesktop}`) !== undefined) {
        this.deactivateTab($tabLink)

        if (tabDisableHash) {
          this.removeHashUrl($tabLink)
        }
      }
      return
    }

    if ($container.data(`${this.data.tabCanActiveMultiple}`) === undefined) {
      this.deactivateTabs($tabLink)
    }

    this.activateTab($tabLink)

    if (tabDisableHash) {
      this.changeHashUrl($tabLink)
    }
  }

  handleLoadHashScroll(e) {
    if (this.isScriptWhoChangeUrl) {
      this.isScriptWhoChangeUrl = false
      return
    }

    if (window.location.hash != '' && window.location.hash.length) {
      let $tabLink = $(`[data-${this.data.tabLink}="${window.location.hash.substring(1)}"]`)

      if ($tabLink.length) {
        this.deactivateTabs($tabLink)
        this.activateTab($tabLink)

        if (this.scrollOnActiveTab) {
          setTimeout(() => Core.scrollTo($tabLink.closest(`[data-${this.containerData}]`), false), 600)
        }
      }
    }
  }

  activateTab($tabLink) {
    let hashLink = $tabLink.data(`${this.data.tabLink}`)
    let $tabContent = $tabLink.closest(this.containerSelector).find(`[data-${this.data.tabContent}="${hashLink}"]`)

    $tabContent.addClass(this.data.active)
    $tabLink.addClass(this.data.active)

    let currentBp = Core.getCurrentBp()

    if (this.scrollOnActiveTab && (currentBp === 'xs' || currentBp === 'sm')) {
      setTimeout(() => {
        Core.scrollTo($tabLink, false)
      }, 300)

      $tabLink.parent().animate({
        scrollLeft: `+=${$tabLink.offset().left - $tabLink.parent().offset().left}px`
      }, 150);
    }

    if ($tabContent.find('[data-slider]')) {
      const sliderController = new Slider()

      $tabContent.find('[data-slider]').each((index, slider) => {
        if (slider.classList.contains('slick-initialized')) {
          $(slider).slick('unslick')
        }
        sliderController.generateSlider(index, slider)
      })
    }
  }

  deactivateTabs($tabLink) {
    let $container = $tabLink.closest(this.containerSelector)

    $container.find(`.${this.data.active}`).removeClass(this.data.active)
    $('header').focus()
  }

  deactivateTab($tabLink) {
    let hashLink = $tabLink.data(`${this.data.tabLink}`)
    let $tabContent = $tabLink.closest(this.containerSelector).find(`[data-${this.data.tabContent}="${hashLink}"]`)

    $tabContent.removeClass(this.data.active)
    $tabLink.removeClass(this.data.active)

    $('header').focus()
  }

  changeHashUrl($tabLink) {
    let hashLink = $tabLink.data(`${this.data.tabLink}`)
    let newHash = `#${hashLink}`

    if (window.location.hash !== newHash) {
      this.isScriptWhoChangeUrl = true
    }
    window.location.hash = newHash
  }

  removeHashUrl() {
    this.isScriptWhoChangeUrl = true
    history.pushState("", document.title, window.location.pathname + window.location.search)
  }
}
